export default __webpack_public_path__ + "static/media/Artboard-41-copy-2.3ed49db5.svg";